import { createActionsHook, StoreActionApi } from 'react-sweet-state';

import {
  createGetOneHook,
  createLoadingHook,
  createRestActions,
  createRestStore,
  RestStoreState,
} from '@intelliarts/ia-react-template';

import { createMutationFailedCheck } from '../../../utils/restMutation';
import { Employee } from '../models/Employee';

export const EMPLOYEE_DETAILS_PATH = '/employees';

const actionConfig = {
  resourcePath: '/employees',
};

const genericActions = createRestActions<Employee, Employee>(actionConfig);
const employeeDetailsActions = {
  ...genericActions,
  clearEmployeeDetails: () => ({ setState }: StoreActionApi<RestStoreState<Employee>>) => {
    setState({ data: [], isLoading: false, changes: [] });
  },
};

export const EmployeeDetailsStore = createRestStore<Employee>({
  actions: employeeDetailsActions,
  actionConfig,
  containerDisplayName: 'employee-details-container',
  onInitAction: null,
});

export const useEmployeeDetailsData = createGetOneHook(EmployeeDetailsStore);
export const useEmployeeDetailsIsLoading = createLoadingHook(EmployeeDetailsStore);
export const useEmployeeDetailsActions = createActionsHook(EmployeeDetailsStore);
export const didEmployeeDetailsMutationFail = createMutationFailedCheck(actionConfig.resourcePath);
